import { Link } from "react-router-dom";
import { services } from "@/mocks/services";

export default function Home() {
  const previewServices = services.slice(0, 4);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20industrial%20galvanizing%20facility%20with%20shiny%20metallic%20surfaces%2C%20warm%20ambient%20lighting%2C%20professional%20manufacturing%20environment%2C%20clean%20and%20organized%20production%20hall%2C%20subtle%20green%20and%20copper%20tones%2C%20editorial%20photography%20style%2C%20high%20detail%2C%20warm%20neutral%20color%20palette&width=1600&height=900&seq=hero-dw-galvanik&orientation=landscape"
            alt="Draude & Wagner Galvanik Produktionshalle"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80" />
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-background-50 text-3xl sm:text-4xl md:text-5xl lg:text-6xl max-w-4xl mx-auto leading-tight mb-4 md:mb-6">
            Metalloberflächenveredelung
            <br />
            <span className="text-accent-400">auf höchstem Niveau</span>
          </h1>
          <p className="text-background-200 text-base sm:text-lg md:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed px-4">
            Draude & Wagner Galvanik GmbH & Co. KG – Ihr zuverlässiger Partner für Verzinken, Phosphatieren und Brünieren in der Verbindungstechnik und Automobilzulieferindustrie.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/leistungen"
              className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Unsere Leistungen
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-3.5 border-2 border-background-300/60 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </section>

      {/* About teaser */}
      <section className="py-14 md:py-20 lg:py-24 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
                Über uns
              </span>
              <h2 className="font-heading font-bold text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4 md:mb-6 leading-tight">
                Leistungsstarke Galvanik aus Lüdenscheid
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
                Die Firma Draude & Wagner GmbH & Co. KG ist ein leistungsstarker Betrieb der Metalloberflächenbeschichtung. Unsere Firmenmitarbeiter mit den Aufgabenschwerpunkten Verzinken, Phosphatieren und Brünieren haben sich zum Ziel gesetzt, den heutigen und zukünftigen Forderungen eines nachhaltigen Umweltschutzes zum Wohle aller voll zu entsprechen.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                Wir veredeln Metallteile der Verbindungstechnik, der Automobilzuliefer- und der Metall- und Elektroindustrie mit höchster Präzision und Qualität.
              </p>
              <Link
                to="/ueber-uns"
                className="inline-flex items-center text-primary-600 font-medium hover:text-primary-700 transition-colors text-sm md:text-base"
              >
                Mehr über uns erfahren
                <span className="ml-2 w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/a9beae72ce070f8c28f07fa94c7d3e14/4e108ccff62555f95397b4919d4a00d4.png"
                alt="Draude &amp; Wagner Galvanik GmbH &amp; Co. KG Firmengeb&auml;ude in L&uuml;denscheid"
                className="w-full h-auto rounded-lg object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services preview */}
      <section className="py-14 md:py-20 lg:py-24 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
                Leistungen
              </span>
              <h2 className="font-heading font-bold text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-3 md:mb-4">
                Unsere Expertise
              </h2>
              <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
                Von der Trommelware bis zur Gestellware – wir bieten maßgeschneiderte Oberflächenlösungen für Ihre Metallbauteile.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {previewServices.map((service) => (
                <Link
                  key={service.id}
                  to="/leistungen"
                  className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-50 rounded-md mb-3 md:mb-4">
                    <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-primary-500 text-lg md:text-xl">
                      <i className={service.icon} />
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-3">
                    {service.description}
                  </p>
                </Link>
              ))}
            </div>

            <div className="text-center mt-8 md:mt-10">
              <Link
                to="/leistungen"
                className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm md:text-base"
              >
                Alle Leistungen ansehen
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Quality / Environment teaser */}
      <section className="py-14 md:py-20 lg:py-24 bg-primary-500">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-3 py-1 bg-primary-400/30 text-background-100 text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
              Qualit&auml;t &amp; Umwelt
            </span>
            <h2 className="font-heading font-bold text-background-50 text-2xl md:text-3xl lg:text-4xl mb-4 md:mb-6 leading-tight">
              Nachhaltigkeit trifft Pr&auml;zision
            </h2>
            <p className="text-background-100/80 leading-relaxed mb-4 text-sm md:text-base">
              Unsere Firmenmitarbeiter haben sich zum Ziel gesetzt, den heutigen und zuk&uuml;nftigen Forderungen eines nachhaltigen Umweltschutzes zum Wohle aller voll zu entsprechen. Alle Prozesse werden unter Ber&uuml;cksichtigung moderner Umweltstandards durchgef&uuml;hrt.
            </p>
            <p className="text-background-100/80 leading-relaxed mb-6 text-sm md:text-base">
              Wir setzen auf energieeffiziente Anlagentechnik, Kreislaufwirtschaftssysteme und kontinuierliche Prozessoptimierung.
            </p>
            <Link
              to="/qualitaet"
              className="inline-flex items-center text-background-50 font-medium hover:text-accent-200 transition-colors text-sm md:text-base"
            >
              Unser Qualit&auml;tsversprechen
              <span className="ml-2 w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 md:py-20 lg:py-24 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading font-bold text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-3 md:mb-4">
              Bereit für eine Zusammenarbeit?
            </h2>
            <p className="text-foreground-600 mb-6 md:mb-8 max-w-2xl mx-auto text-sm md:text-base">
              Kontaktieren Sie uns für ein unverbindliches Angebot oder besuchen Sie uns vor Ort in Lüdenscheid. Wir beraten Sie gerne persönlich.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm md:text-base"
              >
                Kontakt aufnehmen
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}